<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container"
      @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="user.certified">
        <div class="right-menu-item">
          <span class="right-menu-item-trigger" @click="openCalculator()"><i class="fas fa-calculator" /> 工资计算器</span>
        </div>
        <div class="right-menu-item" v-if="appCode.includes('YY00010')">
          <span class="right-menu-item-trigger" @click="viewSocialInsuranceStandard()"><i class="fas fa-book" />
            社保政策库</span>
        </div>
        <div class="right-menu-item">
          <MiniAppQrCode>
            <template #trigger="{ list }"><span class="right-menu-item-trigger" v-show="list.length > 0"><i
                  class="fas fa-qrcode" /> 小程序二维码</span></template>
          </MiniAppQrCode>
        </div>
        <div class="right-menu-item">
          <download-center>
            <template #trigger="{ toggle }"><span class="right-menu-item-trigger" @click="toggle"><i
                  class="fas fa-download" /> 下载中心</span></template>
          </download-center>
        </div>
        <div class="right-menu-item">
          <message-bell>
            <template #trigger><span class="right-menu-item-trigger" @click="goMessageCenter"><i class="fas fa-bell" />
                消息中心</span></template>
          </message-bell>
        </div>
        <!-- <div class="right-menu-item" v-if="appCode.includes('YY01001')">
          <recommend-gift />
        </div> -->
        <div class="right-menu-item" v-if="appCode.includes('YY01001')">
          <ent-assets />
        </div>
      </template>
      <div class="right-menu-item" v-else>
        <ent-certify />
      </div>
      <div class="right-menu-item">
        <User>
          <template #trigger><span class="right-menu-item-trigger user-info"><i class="fas fa-user-circle" /> <span
                class="user-info-text">
                <span class="user-name">{{ user.realName }}</span>
                <span>{{ user.roleNames }}</span>
              </span></span></template>
        </User>
      </div>
    </div>


    <social-insurance-standard :visible.sync="socialInsuranceStandardDialog"></social-insurance-standard>

    <!-- 协议弹窗 -->
    <LoginAgreement :visible.sync="loginAgreementDialog" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import LoginAgreement from '@/views/loginAgreement'
import MessageBell from '@/components/MessageBell'
import DownloadCenter from '@/components/DownloadCenter'
import EntCertify from './EntCertify'
import EntAssets from './EntAssets'
import RecommendGift from './RecommendGift'
import Calculator from './Calculator'
import SocialInsuranceStandard from '@/views/socialInsuranceManage/SocialInsuranceStandard.vue'
import MiniAppQrCode from './MiniAppQrCode'
import User from './User.vue'


export default {
  components: {
    Breadcrumb,
    Hamburger,
    LoginAgreement,
    MessageBell,
    DownloadCenter,
    EntCertify,
    EntAssets,
    RecommendGift,
    SocialInsuranceStandard,
    Calculator,
    MiniAppQrCode,
    User
  },
  data() {
    return {
      // 是否显示登录协议弹窗
      loginAgreementDialog: false,
      // 是否显示社保政策弹窗
      socialInsuranceStandardDialog: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'device',
      'user',
      'baseApi',
      'verifyInfo',
      'platformInfo',
      'appCode',
      'pwdExpired',
      'pwdExpiredPending'
    ]),
    // 密码过期（或正在校验是否过期）时，修改密码弹窗优先级最高，其它全局弹窗需让位
    blockedByPwdExpired() {
      return this.pwdExpired || this.pwdExpiredPending
    }
  },
  watch: {
    'user.agreeProtocol': function() {
      this.syncAgreementDialog()
    },
    // 密码过期弹窗弹出时关闭协议弹窗（改密后需重新登录，无需补弹协议）
    blockedByPwdExpired(val) {
      if (val) {
        this.loginAgreementDialog = false
      }
    }
  },
  created() {
    this.syncAgreementDialog()
  },
  methods: {
    // 同步协议弹窗显隐：密码过期弹窗存在时不展示
    syncAgreementDialog() {
      if (this.blockedByPwdExpired) {
        this.loginAgreementDialog = false
        return
      }
      this.loginAgreementDialog = !!(!this.user.agreeProtocol && this.user.certified)
    },
    // 打开计算器
    openCalculator() {
      let url = 'http://h5.saas.taxll.com/calculator'
      if (this.appCode.includes('YY00011')) {
        url += '?showOfficialWebsite=true'
      }
      // 宽600高700弹窗居中打开
      window.open(url, '工资&个税计算器', 'width=600,height=700')
    },
    // 查看社保政策
    viewSocialInsuranceStandard() {
      this.socialInsuranceStandardDialog = true
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    // 跳转到消息中心（消息列表）
    goMessageCenter() {
      this.$router.push({
        path: "/messageCenter"
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dropdown-menu {
  padding-top: 0px;
  padding-bottom: 0px;

  .el-dropdown-menu__item {
    padding: 0;

  }

  .user-dropdown {

    a,
    span {
      display: block;
      cursor: pointer;
      height: 42px;
      line-height: 22px;
      width: 200px;
      font-size: 14px;
      padding: 10px 20px;
      color: #606266;
      font-weight: bold;
      text-align: center;
      border-bottom: 1px solid rgb(243, 237, 237);

      &:hover {
        background-color: #ecf5ff;
        color: #66b1ff;
      }
    }
  }
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
  // margin: 0 14px;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    display: flex;
    align-items: center;
    float: right;
    padding-right: 24px;
    height: 100%;

    .right-menu-item {

      //   margin-left: 15px;
      .right-menu-item-trigger {
        line-height: 1.5;
        display: flex;
        align-items: center;
        gap: 3px;
        padding: 6px 12px;
        border-radius: 6px;
        color: #6b7280;
        font-size: 12px;
        font-weight: 500;
        text-decoration: none;
        transition: all 0.2s;
        white-space: nowrap;
        cursor: pointer;
        flex-direction: column;

        i {
          font-size: 16px
        }

        &:hover {
          color: #2A5CAA;
          background: rgba(42, 92, 170, 0.06);
        }



        &.user-info {
          gap: 10px;
          margin-left: 10px;

          i {
            font-size: 30px;
            color: #3b82f6;
          }

          flex-direction: row;

          .user-info-text {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .user-name {
              font-weight: bold;
            }
          }
        }
      }
    }

    // &>.right-menu-item:not(:last-child) {
    //   display: flex;
    //   align-items: center;

    //   &::after {
    //     content: '';
    //     display: block;
    //     width: 1px;
    //     height: 28px;
    //     background: #E5E7EB;
    //     margin: 0 16px;
    //   }
    // }
  }
}

.shadow-btn {
  color: #0079FE;
  box-shadow: 0px 0px 3px rgba(0, 121, 254, 1);
  font-weight: bold;
}
</style>
